import React from "react";
// Comps
// Css
import classes from "./Supervisor.module.scss";

const Supervisor: React.FC = () => {
  return (
    <div className={classes.container}>
      <p className={`${classes.heading} ${classes.supervisor}`}>
        Supervised by
      </p>
      <strong className={`${classes.strong} ${classes.supervisor}`}>
        Dr. Elham Mahmoudzadeh
      </strong>
      <p>Assistant Professor at Isfahan University of Technology</p>
      <p className={classes.heading}>Faculty of</p>
      <strong className={classes.strong}>
        Software & Information Technology
      </strong>
      <p className={classes.heading}>Contact:</p>
      <a href="mailto:mahmoudzadeh@iut.ac.ir" className={classes.link}>
        <strong className={classes.strong}>mahmoudzadeh@iut.ac.ir</strong>
      </a>
    </div>
  );
};

export default Supervisor;
